import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    this.restore()
    this.morphHandler = () => this.restore()
    document.addEventListener("turbo:morph", this.morphHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.morphHandler)
  }

  restore() {
    if (!this.hasKeyValue) return

    try {
      const saved = localStorage.getItem(this.keyValue)
      if (saved !== null && this.element.value === this.element.defaultValue) {
        this.element.value = saved
        if (saved !== this.element.defaultValue) {
          this.dispatch("restored")
        }
      }
    } catch {
      // ignore
    }
  }

  save() {
    if (!this.hasKeyValue) return

    try {
      const text = this.element.value
      if (text === this.element.defaultValue) {
        localStorage.removeItem(this.keyValue)
      } else {
        localStorage.setItem(this.keyValue, text)
      }
    } catch {
      // ignore
    }
  }

  clear() {
    if (!this.hasKeyValue) return
    try { localStorage.removeItem(this.keyValue) } catch {}
  }
}
